import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}
export function SectionWrapper({
  children,
  title,
  subtitle
}: SectionWrapperProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -15
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="max-w-5xl mx-auto p-6 md:p-10" data-id="element-562">
      <div className="mb-10" data-id="element-563">
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight" data-id="element-564">
          {title}
        </h1>
        {subtitle && <p className="text-slate-500 mt-3 text-lg max-w-3xl leading-relaxed" data-id="element-565">
            {subtitle}
          </p>}
      </div>
      <div className="space-y-8" data-id="element-566">{children}</div>
    </motion.div>;
}